import { render, staticRenderFns } from "./nuevoUsuario.vue?vue&type=template&id=c80681b2&"
import script from "./nuevoUsuario.vue?vue&type=script&lang=js&"
export * from "./nuevoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports